import { Card, CardBody, CardFooter, Col, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import CommonRaisedInput from "./Common/CommonRaisedInput";
import { RaiseInputStyles, RaisedCancel, RaisedComments, RaisedEmailAddress, RaisedEmailAddressPlaceholder, RaisedPassword, RaisedPasswordPlaceholder, RaisedSelectYourFavoritePixelstrapTheme, RaisedSubmit, SelectTheColorYouLikeBelow } from "../../../../Constant";
import CommonSelectInput from "../Common/CommonSelectInput";
import { RAISED_COLOR_LIST, RAISED_INPUT_STYLES, RAISED_LIST } from "../../../../Data/FormControl/BaseInput";

const RaiseInputStyle = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={RaiseInputStyles} span={RAISED_INPUT_STYLES} />
        <Form className="theme-form dark-inputs">
          <CardBody>
            <CommonRaisedInput inputType="email" label={RaisedEmailAddress} placeholder={RaisedEmailAddressPlaceholder} />
            <CommonRaisedInput inputType="password" label={RaisedPassword} placeholder={RaisedPasswordPlaceholder} />
            <CommonSelectInput label={RaisedSelectYourFavoritePixelstrapTheme} inputClass="input-air-primary" span={RAISED_LIST} />
            <CommonSelectInput label={SelectTheColorYouLikeBelow} inputClass="input-air-primary" span={RAISED_COLOR_LIST} multiple/>
            <CommonRaisedInput inputType="textarea" label={RaisedComments} rows={4} />
          </CardBody>
          <CardFooter className="text-end">
            <Btn color="primary" className="me-3" type="submit">{RaisedSubmit}</Btn>
            <Btn color="light" type="reset">{RaisedCancel}</Btn>
          </CardFooter>
        </Form>
      </Card>
    </Col>
  );
};

export default RaiseInputStyle;
